export default {
  shuffle(array) {
    //https://github.com/coolaj86/knuth-shuffle
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  },

  search(val, prop, array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][prop] === val) {
        return array[i];
      }
    }
  },

  sort(obj, param) {
    return obj.sort(function(a, b) {
      if (a[param] < b[param]) return -1;
      if (a[param] > b[param]) return 1;
      return 0;
    });
  },

  dumbDate(date) {
    if (date) {
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        "-" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate())
      );
    }
  },

  ptbrDate(d) {
    return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
  },

  isScrolledIntoView(el, full = false, offender) {
    let rect = el.getBoundingClientRect();

    let elemTop = rect.top;
    let elemBottom = rect.bottom;

    // Only completely visible elements return true:
    //let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:

    let isVisible = elemTop < window.innerHeight && elemBottom >= 0;

    if (full) isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;

    return isVisible;
  },

  getProp(propertyToRetrieveValue, indexValue, indexName, list) {
    let registro = this.search(indexValue, indexName, list);
    if (registro) {
      return registro[propertyToRetrieveValue];
    }
  },

  moneyToFix2(brl) {
    if (typeof brl === "string") {
      if (brl.substr(0, 1) === "R") {
        let a = brl.split(" ")[1];
        if (a) return parseFloat(a.replace(".", "").replace(",", "."));
      } else {
        return parseFloat(brl).toFixed(2);
      }
    } else {
      return parseFloat(brl).toFixed(2);
    }
  },

  fix2ToMoney(fix, sym = false) {
    let a = sym ? "R$ " : "";
    return (
      a +
      parseFloat(fix)
        .toFixed(2)
        .toString()
        .replace(".", ",")
    );
  },

  clean(obj) {
    for (var propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === "fornecedor"
      ) {
        delete obj[propName];
      }
    }
  },

  isReset(prop, val) {
    return prop === val;
  },

  cleanCompare(obj1, obj2) {
    for (let propName in obj1) {
      if (
        obj1[propName] === obj2[propName] ||
        obj1[propName] === null ||
        obj1[propName] === undefined
      ) {
        delete obj[propName];
      }
    }
  },
  //Kudos: Josh from Qaribou, https://stackoverflow.com/questions/5700636/using-javascript-to-perform-text-matches-with-without-accented-characters
  accentFold(inStr) {
    return inStr.replace(
      /([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
      function(str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return "a";
        else if (c) return "c";
        else if (e) return "e";
        else if (i) return "i";
        else if (n) return "n";
        else if (o) return "o";
        else if (s) return "s";
        else if (u) return "u";
        else if (y) return "y";
        else if (ae) return "ae";
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/plugins/helpers.js